var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassesSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.154,
    height: 17,
    viewBox: "0 0 23.154 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#7f7f7f;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 22.154,
    transform: "translate(0 16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17.231,
    height: 12.308,
    rx: 1,
    transform: "translate(2.462 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.692 2.769)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.051,
    cy: 2.051,
    rx: 2.051,
    ry: 2.051,
    transform: "translate(1.026 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3.077V2.051A2.051,2.051,0,0,1,2.051,0H4.1A2.051,2.051,0,0,1,6.154,2.051V3.077",
    transform: "translate(0 6.154)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassesSearch);
export default __webpack_public_path__ + "static/media/classes-search.58594a1d98b34ba7f1e08bbcce7564bc.svg";
export { ForwardRef as ReactComponent };